export const SIGN_IN_PATH = '/sign-in';
export const OAUTH_CALLBACK_GOOGLE_PATH = '/auth/callback/google';
export const OAUTH_CALLBACK_MICROSOFT_PATH = '/auth/callback/microsoft';
export const SIGN_IN_TOKEN_PATH = `${SIGN_IN_PATH}/:token/:params?`;
export const FORGOTTEN_PASSWORD_PATH = '/forgotten-password';
export const RESET_PASSWORD_PATH = `/reset-password`;
export const RESET_PASSWORD_TOKEN_PATH = `${RESET_PASSWORD_PATH}/:token`;
export const REGISTER_PATH = '/register/:id/:param?';
export const TOKEN_PATH = ':token';

export const QUESTIONNAIRE_PATH = '/questionnaire/:id';
export const PARTICIPANT_PATH = '/participant';

export const PERFEED_PATH = '/perfeed';

export const PERFEED_FEEDBACK_PATH = `${PERFEED_PATH}/feedback`;
export const PERFEED_FEEDBACK_RATING_PATH = `${PERFEED_FEEDBACK_PATH}/rating`;

export const PERFEED_REQUEST_PATH = `${PERFEED_PATH}/request`;
export const PERFEED_REQUEST_ASK_PATH = `${PERFEED_REQUEST_PATH}/ask`;
export const PERFEED_REQUEST_SETTINGS_PATH = `${PERFEED_REQUEST_PATH}/settings`;
export const PERFEED_REQUEST_RATING_POINT_PATH = `${PERFEED_REQUEST_PATH}/rating-point`;

export const PERFEED_RESULTS_PATH = `${PERFEED_PATH}/results`;

export const PROFILE_PATH = '/profile';

export const OUTPUT_REPORT_PATH = '/results';
export const OUTPUT_REPORT_LIST_PATH = `${OUTPUT_REPORT_PATH}/:page?`;
export const OUTPUT_REPORT_DETAIL_PATH = `${OUTPUT_REPORT_PATH}/detail/:reportId/:resultId`;

export const FORBIDDEN_PATH = '/403';
export const NOT_FOUND_PATH = '/404';

export const PASSWORD_PATH = '/change-password';

export const ADMIN_PATH = '/admin';
export const ADMIN_DASHBOARD_PATH = 'dashboard';
export const ADMIN_PRODUCT_PATH = ':productId';
export const ADMIN_CREATE_PATH = 'create';
export const ADMIN_USERS_PATH = 'users';
export const ADMIN_USER_DETAIL_PATH = ':userId';
export const ADMIN_USER_PROJECTS_PATH = 'projects';
export const ADMIN_USER_MANAGED_PROJECTS_PATH = 'managed-projects';

export const ADMIN_COMPANY_PATH = ':companyId';
export const ADMIN_COMPANIES_PATH = 'companies';
export const ADMIN_PROJECT_DETAIL_PATH = 'project/:projectId';

export const ADMIN_PROJECT_CREATE_PATH = 'create/*';
export const ADMIN_PROJECT_PACKAGES_PATH = 'packages';
export const ADMIN_PROJECT_QUESTIONNAIRES_PATH = 'questionnaires';
export const ADMIN_PROJECT_QUESTIONNAIRES_DETAIL_PATH = ':questionnaireId';
export const ADMIN_PROJECT_PARTICIPANTS_PATH = 'participants';
export const ADMIN_PROJECT_TRANSLATIONS_PATH = 'translations';
export const ADMIN_PROJECT_JOBMATCH_REPORTS_PATH = 'jobmatch';
export const ADMIN_PROJECT_ADMIN_PATH = 'admin';
export const ADMIN_PROJECT_STATISTICS_PATH = 'statistics';

export const ADMIN_PROJECT_JOB_MATCH = 'job-matching/*';
export const ADMIN_PROJECT_JOB_MATCH_PROFILES = 'profiles';
export const ADMIN_PROJECT_JOB_MATCH_OUTPUT = 'output/*';

export const ADMIN_PROJECT_360_QUESTIONS_PATH = 'questions';
export const ADMIN_PROJECT_360_SCALES_PATH = 'scales';
export const ADMIN_PROJECT_360_SCALE_DETAIL_PATH = ':scaleId';
export const ADMIN_PROJECT_360_SCALES_EDIT_PATH = 'edit';

export const ADMIN_PROJECT_SPOKOJENOST_CRITERIA_PATH = 'criteria';

export const ADMIN_PROJECT_CONFIG_PATH = 'config';

export const ADMIN_INVITE_PATH = 'invite';
export const ADMIN_INVITE_DETAIL_PATH = ':inviteId';
export const ADMIN_INVITE_CONTENT_PATH = 'content';
export const ADMIN_INVITE_RECAP_PATH = 'recap';

export const INTEGRATION_PATH = '/integration';

export const ADMIN_IMPORT_PATH = 'import';

export const ADMIN_TEAMS_PATH = 'teams';
export const ADMIN_TEAM_DETAIL_PATH = ':teamId';

export const ADMIN_REPORTS_PATH = 'reports';
export const ADMIN_RESULT_PATH = ':reportId/result/:resultId';
export const ADMIN_REPORTS_360_PATH = `${ADMIN_REPORTS_PATH}/360`;
export const ADMIN_REPORTS_PSYCHODIAGNOSTICS_PATH = `${ADMIN_REPORTS_PATH}/psychodiagnostics`;

export const EDIT_PATH = 'edit/*';

// Absolute admin paths (for use with generatePath in Link/navigate)
export const ADMIN_DASHBOARD_ABS_PATH = `${ADMIN_PATH}/dashboard`;
export const ADMIN_PRODUCT_ABS_PATH = `${ADMIN_DASHBOARD_ABS_PATH}/:productId`;
export const ADMIN_PROJECT_DETAIL_ABS_PATH = `${ADMIN_PRODUCT_ABS_PATH}/project/:projectId`;
export const ADMIN_PROJECT_STATISTICS_ABS_PATH = `${ADMIN_PROJECT_DETAIL_ABS_PATH}/statistics`;
export const ADMIN_PROJECT_EDIT_ABS_PATH = `${ADMIN_PROJECT_DETAIL_ABS_PATH}/edit`;
export const ADMIN_PROJECT_CREATE_ABS_PATH = `${ADMIN_PROJECT_DETAIL_ABS_PATH}/create`;
export const ADMIN_PROJECT_CREATE_TRANSLATIONS_ABS_PATH = `${ADMIN_PROJECT_CREATE_ABS_PATH}/translations`;
export const ADMIN_PROJECT_PACKAGES_ABS_PATH = `${ADMIN_PROJECT_EDIT_ABS_PATH}/packages`;
export const ADMIN_PROJECT_QUESTIONNAIRES_ABS_PATH = `${ADMIN_PROJECT_EDIT_ABS_PATH}/questionnaires`;
export const ADMIN_PROJECT_PARTICIPANTS_ABS_PATH = `${ADMIN_PROJECT_EDIT_ABS_PATH}/participants`;
export const ADMIN_PROJECT_TRANSLATIONS_ABS_PATH = `${ADMIN_PROJECT_EDIT_ABS_PATH}/translations`;
export const ADMIN_PROJECT_ADMIN_ABS_PATH = `${ADMIN_PROJECT_DETAIL_ABS_PATH}/admin`;
export const ADMIN_PROJECT_CONFIG_ABS_PATH = `${ADMIN_PROJECT_DETAIL_ABS_PATH}/config`;
export const ADMIN_PROJECT_CREATE_RECAP_ABS_PATH = `${ADMIN_PROJECT_CREATE_ABS_PATH}/recap`;

export const ADMIN_INVITE_ABS_PATH = `${ADMIN_PROJECT_DETAIL_ABS_PATH}/invite`;
export const ADMIN_INVITE_DETAIL_ABS_PATH = `${ADMIN_INVITE_ABS_PATH}/:inviteId`;
export const ADMIN_INVITE_EDIT_ABS_PATH = `${ADMIN_INVITE_DETAIL_ABS_PATH}/edit`;
export const ADMIN_INVITE_CONTENT_ABS_PATH = `${ADMIN_INVITE_EDIT_ABS_PATH}/content`;
export const ADMIN_INVITE_RECAP_ABS_PATH = `${ADMIN_INVITE_EDIT_ABS_PATH}/recap`;

export const ADMIN_TEAMS_ABS_PATH = `${ADMIN_PROJECT_DETAIL_ABS_PATH}/teams`;
export const ADMIN_TEAM_DETAIL_ABS_PATH = `${ADMIN_TEAMS_ABS_PATH}/:teamId`;

export const ADMIN_REPORTS_ABS_PATH = `${ADMIN_PROJECT_DETAIL_ABS_PATH}/reports`;
export const ADMIN_REPORTS_JOBMATCH_ABS_PATH = `${ADMIN_REPORTS_ABS_PATH}/jobmatch`;
export const ADMIN_RESULT_ABS_PATH = `${ADMIN_REPORTS_ABS_PATH}/:reportId/result/:resultId`;
export const ADMIN_RESULT_JOBMATCH_ABS_PATH = `${ADMIN_REPORTS_JOBMATCH_ABS_PATH}/:reportId/result/:resultId`;
export const ADMIN_JOB_MATCH_PROFILES_ABS_PATH = `${ADMIN_PROJECT_DETAIL_ABS_PATH}/profiles`;

export const ADMIN_360_SCALES_ABS_PATH = `${ADMIN_PROJECT_DETAIL_ABS_PATH}/scales`;
export const ADMIN_PROJECT_SPOKOJENOST_CRITERIA_ABS_PATH = `${ADMIN_PROJECT_DETAIL_ABS_PATH}/criteria`;
export const ADMIN_USERS_ABS_PATH = `${ADMIN_PATH}/users`;
export const ADMIN_USER_DETAIL_ABS_PATH = `${ADMIN_USERS_ABS_PATH}/:userId`;
export const ADMIN_COMPANIES_ABS_PATH = `${ADMIN_PATH}/companies`;
export const ADMIN_COMPANY_DETAIL_ABS_PATH = `${ADMIN_COMPANIES_ABS_PATH}/:companyId`;
export const ADMIN_COMPANY_TEAMS_ABS_PATH = `${ADMIN_PATH}/teams`;
export const ADMIN_COMPANY_TEAM_DETAIL_ABS_PATH = `${ADMIN_COMPANY_TEAMS_ABS_PATH}/:teamId`;
export const ADMIN_REPORTS_360_ABS_PATH = `${ADMIN_REPORTS_ABS_PATH}/360`;
export const ADMIN_REPORTS_PSYCHODIAGNOSTICS_ABS_PATH = `${ADMIN_REPORTS_ABS_PATH}/psychodiagnostics`;
export const ADMIN_PROJECT_360_QUESTIONS_ABS_PATH = `${ADMIN_PROJECT_DETAIL_ABS_PATH}/questions`;
export const ADMIN_PROJECT_360_SCALES_ABS_PATH = `${ADMIN_PROJECT_DETAIL_ABS_PATH}/scales`;
export const ADMIN_PROJECT_JOB_MATCH_PROFILES_ABS_PATH = `${ADMIN_PROJECT_DETAIL_ABS_PATH}/job-matching/profiles`;
export const ADMIN_QUESTIONNAIRES_ABS_PATH = `${ADMIN_PRODUCT_ABS_PATH}/questionnaires`;
export const ADMIN_QUESTIONNAIRE_DETAIL_ABS_PATH = `${ADMIN_QUESTIONNAIRES_ABS_PATH}/:questionnaireId`;
export const ADMIN_QUESTIONNAIRE_EDIT_ABS_PATH = `${ADMIN_QUESTIONNAIRE_DETAIL_ABS_PATH}/edit`;
export const ADMIN_QUESTIONNAIRE_SCALES_ABS_PATH = `${ADMIN_QUESTIONNAIRES_ABS_PATH}/scales`;
export const ADMIN_SCALE_ABS_PATH = `${ADMIN_QUESTIONNAIRE_SCALES_ABS_PATH}/:scaleId`;
export const ADMIN_SCALE_CREATE_ABS_PATH = `${ADMIN_SCALE_ABS_PATH}/create`;
export const ADMIN_SCALE_EDIT_ABS_PATH = `${ADMIN_SCALE_ABS_PATH}/edit`;
